import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

require('./stylesheets/Good.css');
require('./stylesheets/Style.css');

ReactDOM.render(<App />, document.getElementById('app'));